"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var TopicRepliesEmptyStatus = function TopicRepliesEmptyStatus() {
  return (0, _preact.h)("div", {
    className: "box box__pad"
  }, (0, _preact.h)("div", {
    className: "box__pad--s box--note"
  }, (0, _preact.h)(_phrase.default, {
    p: "no.replies.box.message"
  })));
};

var _default = TopicRepliesEmptyStatus;
exports.default = _default;